export enum MarketingRoutes {
    Pipelines = 'pipelines',
    FieldsSettings = 'fields-settings',
    TransparentMarketing = 'transparent-marketing',
}
